import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

/**
 * Vozač je korisnik aplikacije ili kontakt iz imenika — dovoljan je jedan, a greška pada
 * na polje koje je u tom trenutku prikazano. Dokumenti su neobavezni.
 */
const requiresDriver = (other: string, message: string) =>
  yup
    .string()
    .nullable()
    .test("driver-required", message, function (value) {
      return !!value || !!this.parent[other];
    });

export const FLEET_VEHICLE_DRIVER_EDIT_FORM_SCHEMA = yup.object().shape({
  contactId: requiresDriver("userId", "Molimo Vas da odaberete kontakt"),
  userId: requiresDriver("contactId", "Molimo Vas da odaberete korisnika"),
});

